import React, { Children, cloneElement, PropTypes } from 'react';
import { Link } from 'react-router';

import { Paper, FlatButton } from 'material-ui';

const { bool, node, object } = PropTypes;

const Stats = ({ children, disabled, style }) => (
  <Paper style={Object.assign({}, style, { textAlign: 'center' }, disabled ? { position: 'relative' } : {})}>
    {disabled && <Paper style={{
      backgroundColor: 'rgba(232, 232, 232, 0.96)',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    }}
    >
    <div style={{ position: 'absolute', top: '50%', transform: 'translateY(-50%)', width: '100%' }}>
      <p style={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '16px', fontWeight: '500', margin: 0, padding: 0 }}>Stats shown after having more than 5 connections.</p>
      <Link to="/connections/add-connections">
        <FlatButton label="Invite Your Current Partners" primary />
      </Link>
    </div>
    </Paper>}
    {!disabled ? children : Children.map(children, (child, key) => cloneElement(child, { disabled, key }))}
  </Paper>
);

Stats.propTypes = {
  children: node,
  disabled: bool,
  style: object,
};

export default Stats;



// WEBPACK FOOTER //
// ./src/app/components/dashboard/Stats.jsx